import { request } from './request';

export type TFeedbackType = 'BUG' | 'QUESTION' | 'OTHER';

export function makeFeedback(data: FormData) {
  return request('post', 'issues', data);
}
